import React from "react";
import { inject, observer } from "mobx-react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { RootStore } from "store/root.store";
import { FEATURE } from "store/types";
import { Button, UnderlineLink } from "components/ui";
import { getInventoryResourceLink } from "tools/utils";
import { FullScreenSvg } from "components/icons";

type InventoryByResourceIdLinkProps = {
  store?: RootStore;
  showLink: boolean;
  useButton?: boolean;
  accountId: string;
  resourceId: string;
  uniqueResourceIdsLength?: number;
};

const InventoryByResourceIdLink = ({
  store,
  showLink,
  useButton,
  accountId,
  resourceId,
  uniqueResourceIdsLength = 0,
}: InventoryByResourceIdLinkProps) => {
  const navigate = useNavigate();
  const isInventoryEnabled = store?.auth.isFeatureEnabled(FEATURE.INVENTORY_PAGE);
  const link = getInventoryResourceLink({ accountId, resourceId });

  if (showLink && isInventoryEnabled) {
    if (uniqueResourceIdsLength > 1) {
      return (
        <Box>
          <UnderlineLink truncate breakWordsLine underline to={link} text={resourceId} />{" "}
          <b>(+{uniqueResourceIdsLength - 1})</b>
        </Box>
      );
    }
    if (useButton) {
      return (
        <Box>
          <Button
            buttonSx={{
              marginRight: "auto",
              svg: {
                width: 16,
                height: 16,
              },
            }}
            inTable
            onClick={() => navigate(link)}
            text="Details"
            customIcon={<FullScreenSvg color="#fff" />}
          />
        </Box>
      );
    }

    return <UnderlineLink truncate breakWordsLine underline to={link} text={resourceId} />;
  }

  if (uniqueResourceIdsLength > 1) {
    return (
      <Box sx={{ wordBreak: "break-word" }}>
        {resourceId} <b>(+{uniqueResourceIdsLength - 1})</b>
      </Box>
    );
  }

  return <Box sx={{ wordBreak: "break-word" }}>{resourceId}</Box>;
};

export default inject("store")(observer(InventoryByResourceIdLink));
